import { useEffect } from "react";
import "./App.css";
import NaturalPersonForm from "./pages/NaturalPersonForm";
import { Route, Routes } from "react-router-dom";
import JuridicalPersonForm from "./pages/JuridicalPersonForm";

const RedirectExternal = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return null;
};

const App = () => {
  return (
    <Routes>
      <Route
        path="/formulario-persona-natural"
        element={<NaturalPersonForm />}
      />
      <Route
        path="/formulario-persona-juridica"
        element={<JuridicalPersonForm />}
      />
      <Route
        path="*"
        element={<RedirectExternal to="https://www.fiduvalor.com.ec" />}
      />
    </Routes>
  );
};

const redirectToFidu = () => {
  window.location.href = "https://www.google.com";
};

export default App;
